import { useState, useRef, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { resetPassword } from "../../api/auth";
import "./reset-password-form.scss";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";

const notificationText =
  "We've sent a link to reset your password. Check your inbox.";

export default function ResetPasswordForm(props: any) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const strings = useSelector(getLocalized);
  const formData = useRef<{ email: string }>({ email: "" });

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { email } = formData.current;
      setLoading(true);

      const result = await resetPassword(email);
      setLoading(false);

      if (result.isOk) {
        history.push("/login");
        notify(notificationText, "success", 2500);
      } else {
        notify(result.message, "error", 2000);
      }
    },
    [history]
  );

  return (
    <form className={"reset-password-form"} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={"email"}
          editorType={"dxTextBox"}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message={strings.getString("required")} />
          <EmailRule message={strings.getString("email")} />
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions
            elementAttr={submitButtonAttributes}
            width={"100%"}
            type={"default"}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={"24px"} height={"24px"} visible={true} />
              ) : (
                strings.getString("reset_my_password")
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={"login-link"}>
            {strings.getString("return_to")}{" "}
            <Link to={"/login"}>{strings.getString("signin")}</Link>
          </div>
        </Item>
      </Form>
    </form>
  );
}

const emailEditorOptions = {
  stylingMode: "filled",
  placeholder: "Email",
  mode: "email",
};
const submitButtonAttributes = { class: "submit-button" };
